import { render } from "./teaTrainInfo.vue?vue&type=template&id=173a5d04&scoped=true"
import script from "./teaTrainInfo.vue?vue&type=script&lang=js"
export * from "./teaTrainInfo.vue?vue&type=script&lang=js"

import "./teaTrainInfo.vue?vue&type=style&index=0&id=173a5d04&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173a5d04"]])

export default __exports__